import { render, staticRenderFns } from "./ReviewModal.vue?vue&type=template&id=a0352d9a"
import script from "./ReviewModal.vue?vue&type=script&lang=ts"
export * from "./ReviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0352d9a')) {
      api.createRecord('a0352d9a', component.options)
    } else {
      api.reload('a0352d9a', component.options)
    }
    module.hot.accept("./ReviewModal.vue?vue&type=template&id=a0352d9a", function () {
      api.rerender('a0352d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/ReviewModal.vue"
export default component.exports